<template>
  <section id="about">
      <br><br>
    <v-row>
      <v-col cols="12">
        <h2 class="display-1 font-weight-thin text-center">Sobre mí</h2>
        <v-responsive class="mt-3 mb-6 mx-auto primary base-divider" max-width="42">
          <v-divider/>
        </v-responsive>
      </v-col>
    </v-row>


    <v-container>
      <v-row>
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="12">
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mt-5">
                            <h3 class="text-justify title  font-bold-light font-weight-light mt-3">Me gusta la ilustración, soy caricaturista amateurs y un amante del diseño UI/UX.</h3>
                            <br>
                            <p class="text-justify title  font-bold-light font-weight-light mt-3">
                              Colaboro con dos empresas enfocadas a la tecnología: <strong>Sofymeet</strong> y <strong>Detalmx</strong>. Ambas dedicadas al desarrollo de sistemas.
                              <br><br>
                              Cuento con el conocimiento, la formación y las competencias específicas requeridas para integrarme a los proyectos de TI.
                            </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4" class="d-none d-md-flex align-center mt-n5">
          <v-img src="@/assets/img/about.png" class="d-block ml-auto mr-auto" contain/>
        </v-col>
      </v-row>
    </v-container>

  
  </section>
</template>

<script>
  export default {
    name: 'AboutComponent',

    
  }
</script>

<style scoped>
#about {
  background-color: #f4f7f5;
}
</style>
